import Layout from "../containers/layout";

const NotFound = () => {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center  relative h-full">
        {/* <h1 className=" fill text-[20rem] font-bold">404 </h1> */}
        <svg
          width="100%"
          // height="50%"
          className="w-full h-auto md:h-1/2 text-[5rem] md:text-[15rem] lg:text-[20rem] font-black md:font-extrabold "
        >
          <text x="50%" y="50%">
            404
          </text>
        </svg>

        <p className=" border-t border-b bg-white py-3 text-sky-900 px-2 font-bold text-sm md:text-xl uppercase tracking-widest">
          Page not found
        </p>
      </div>
    </Layout>
  );
};

export default NotFound;
